// Include scss
import "../scss/index.scss";

// Images
import "./images.js";

/* 
    Libs 
*/

// Lazyload
import LazyLoad from "vanilla-lazyload";
var myLazyLoad = new LazyLoad();
myLazyLoad.update();

// Swiper
import Swiper from 'swiper';
import {Pagination, EffectFade, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const swiper = new Swiper('#js-test-slider', {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
        el: "#js-test-slider-pagination",
        clickable: true,
    }
});

// MagicScroll + GSAP
import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from "gsap"; // What to import from gsap
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
 
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax); // Pass gsap import to Scrollmagic

var controller = new ScrollMagic.Controller();
var scene = new ScrollMagic.Scene({triggerElement: "#my-sticky-element-trigger", duration: "50%"})
    .setTween("#my-sticky-element", {
        backgroundColor: "blue", 
        scale: 0.7,
        x: '300px',
        rotate: 180
    })
    .addTo(controller);



window.addEventListener('DOMContentLoaded', () => {
    for(let slider of document.querySelectorAll('.js-case-sider-type-1')) {

        let progressObject = slider.querySelector(".js-case-sider-type-1__nav");
        let aboutText = slider.querySelector(".js-case-sider-type-1__text");

        new Swiper(slider, {
            modules: [Autoplay, Pagination, EffectFade],
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 0,
            effect: 'fade',
            pagination: {
                el: slider.querySelector('.js-case-sider-type-1__nav'),
                clickable: true,
                bulletClass: 'ucase-slider__navItem',
                bulletActiveClass: 'ucase-slider__navItem_current',
                renderBullet: function (index, className) {
                    return '<div class="' + className + '">' + (index + 1) + "<div class=\"ucase-slider__navProgress\"></div></div>";
                }
            },
            autoplay: {
                delay: 3000,
            },
            fadeEffect: {
                crossFade: true
            },
            on: {
                autoplayTimeLeft(s, time, progress) {
                    for(let progressObj of progressObject.querySelectorAll('.ucase-slider__navProgress')) {
                        progressObj.style.setProperty("width", (100 * (1-progress)) + "%");
                    }
                },
                slideChange(swiper) {
                    aboutText.innerHTML = swiper.slides[swiper.activeIndex].dataset.text;
                },
                afterInit: function (swiper) {
                    aboutText.innerHTML = swiper.slides[swiper.activeIndex].dataset.text;
                },
            }
        });
    }



    let firstVideoBlock = document.querySelector('.js-fullvideo');
    if(firstVideoBlock) {
        let firstVideoPlay = firstVideoBlock.querySelector('.js-video-play');
        let firstVideoDesktop = firstVideoBlock.querySelector('.js-video-d');
        firstVideoDesktop.play();
        firstVideoPlay.style.display = "none";
    }


    for(let videoBlock of document.querySelectorAll('.js-fullvideo')) {
        let videoDesktop = videoBlock.querySelector('.js-video-d');
        let videoPlay    = videoBlock.querySelector('.js-video-play');

        videoPlay.addEventListener('click', function(e) {
            e.stopPropagation();
            videoDesktop.play();
        });

        /*
        videoDesktop.addEventListener('click', function(e){
            e.stopPropagation();
            videoDesktop.pause();
        });
        */

        videoDesktop.addEventListener('pause', function() {
            videoPlay.style.display = "block";
        });

        videoDesktop.addEventListener('play', function() {
            videoPlay.style.display = "none";
        });

        window.addEventListener('resize', function(){
            if(this.window.innerWidth < 1240) {
                videoDesktop.pause();
            }
        })

    }
});